export type Token = {};

/**
 * An array that is capable of storing same elements multiple times at once
 * and distinguish between them using their representative tokens
 */
export default class TokenizedArray<T> {
    private readonly arrayOfElements = new Array<T>();
    private readonly arrayOfTokens = new Array<Token>();

    public readonly elements: ReadonlyArray<T> = this.arrayOfElements;
    public readonly tokens: ReadonlyArray<Token> = this.arrayOfTokens;

    public getLength() {
        return this.tokens.length;
    }

    public add(element: T) {
        const indexToken = {};
        this.arrayOfElements.push(element);
        this.arrayOfTokens.push(indexToken);
        return indexToken;
    }

    public safeRemove(indexToken: Token) {
        return this.safeRemoveAtIndex(this.tokens.indexOf(indexToken));
    }

    public safeRemoveAtIndex(index: number) {
        if (this.tokens[index]) {
            this.arrayOfElements.splice(index, 1);
            this.arrayOfTokens.splice(index, 1);
            return true;
        }
        return false;
    }

    public pop(): T | undefined {
        this.arrayOfTokens.pop();
        return this.arrayOfElements.pop();
    }

    public removeAll() {
        this.arrayOfElements.length = 0;
        this.arrayOfTokens.length = 0;
    }
}
